import './App.css';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/homepage/Home'
import Project from './components/projects/Projects';

function App() {
  return (
    <div className="App">
      {/* removing temporarily <Navbar/> */}
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/projects" element={<Project/>}/>
      </Routes>
    </div>
  );
}

export default App;
